// ********************************************************
//
// IMPORT
//
// ********************************************************
import AssetService from '@/services/AssetService'
import ImageService from '@/services/ImageService'
import ThreeService from '@/services/ThreeService'
import SoundService from '@/services/SoundService'

//import imageManifest from '@/config/manifests/images'
import soundManifest from '@/config/manifests/sound'
import threeManifest from '@/config/manifests/three'

import '@/services/ResizeService'
// import '@/services/AnalyticsService'
import Raf from '@/helpers/Raf'
import Env from '@/config/env'
import Timeout from '@/helpers/PromiseTimeout'
import console from 'src/services/ConsoleService'

import store from '@/store'
import { LOAD } from '@/config/app'

import gsap from 'gsap'
window.gsap = gsap
// import { ExpoScaleEase, RoughEase, SlowMo } from 'gsap/EasePack'
// import { CSSRulePlugin } from 'gsap/CSSRulePlugin'
// import { Draggable } from 'gsap/Draggable'
// import { EaselPlugin } from 'gsap/EaselPlugin'
// import { MotionPathPlugin } from 'gsap/MotionPathPlugin'
// import { PixiPlugin } from 'gsap/PixiPlugin'
// import { TextPlugin } from 'gsap/TextPlugin'
// import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
// import { CustomEase } from 'gsap/CustomEase'
// import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin'
// import { GSDevTools } from 'gsap/GSDevTools'
// import { InertiaPlugin } from 'gsap/InertiaPlugin'
// import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin'
// import { MotionPathHelper } from 'gsap/MotionPathHelper'
// import { Physics2DPlugin } from 'gsap/Physics2DPlugin'
// import { PhysicsPropsPlugin } from 'gsap/PhysicsPropsPlugin'
// import { ScrambleTextPlugin } from 'gsap/ScrambleTextPlugin'
// import { SplitText } from 'gsap/SplitText'
// import { CustomBounce } from 'gsap/CustomBounce'
// import { CustomWiggle } from 'gsap/CustomWiggle'

gsap
  .registerPlugin
  // CSSRulePlugin,
  // Draggable,
  // EaselPlugin,
  // MotionPathPlugin,
  // PixiPlugin,
  // TextPlugin,
  // ScrollToPlugin,
  // CustomEase,
  // DrawSVGPlugin
  // GSDevTools,
  // InertiaPlugin,
  // MorphSVGPlugin,
  // MotionPathHelper,
  // Physics2DPlugin,
  // PhysicsPropsPlugin,
  // ScrambleTextPlugin,
  // SplitText,
  // CustomBounce,
  // CustomWiggle,
  // ExpoScaleEase,
  // RoughEase,
  // SlowMo
  ()

// ********************************************************
//
// DOCUMENT
//
// ********************************************************
const loadDocument = function () {
  return new Promise(resolve => {
    const onReady = function () {
      setTimeout(resolve, 1)
    }

    if (document.readyState === 'complete') {
      onReady()
    } else {
      document.onreadystatechange = () => {
        if (document.readyState === 'complete') {
          onReady()
        }
      }
    }
  })
}

// ********************************************************
//
// APP
//
// ********************************************************
async function initApp() {
  // LOAD FRAMEWORK
  store.commit('app/setLoadState', LOAD.STATES.FRAMEWORK_LOADING)
  const imageManifest = await ImageService.getManifest()
  await loadDocument()
  Raf.start()
  await import('./main')

  await Timeout(0)

  store.commit('app/setLoadState', LOAD.STATES.FRAMEWORK_LOADED)

  await Timeout(0)

  store.commit('app/setLoadState', LOAD.STATES.CRITICAL_LOADING)
  await AssetService.load(imageManifest, 2, LOAD.GROUPS.CRITICAL)
  await ImageService.load(imageManifest, 2, LOAD.GROUPS.CRITICAL)
  store.commit('app/setLoadState', LOAD.STATES.CRITICAL_LOADED)

  await Timeout(0)

  store.commit('app/setLoadState', LOAD.STATES.MAIN_LOADING)
  await AssetService.load(imageManifest, 2, LOAD.GROUPS.MAIN)
  await ImageService.load(imageManifest, 2, LOAD.GROUPS.MAIN)
  await ThreeService.load(threeManifest, 2, LOAD.GROUPS.MAIN)
  await SoundService.load(soundManifest, LOAD.GROUPS.MAIN)
  store.commit('app/setLoadState', LOAD.STATES.MAIN_LOADED)

  await Timeout(0)

  // COMPLETE
  store.commit('app/setLoadState', LOAD.STATES.COMPLETE)
  store.dispatch('app/getVersion')

  await ImageService.load(imageManifest, 2, LOAD.GROUPS.EPOCH_1)
  await ImageService.load(imageManifest, 2, LOAD.GROUPS.EPOCH_2)
  await ImageService.load(imageManifest, 2, LOAD.GROUPS.EPOCH_3)
  await ImageService.load(imageManifest, 2, LOAD.GROUPS.EPOCH_4)

  await SoundService.load(soundManifest, LOAD.GROUPS.EPOCH_4)
}

// ********************************************************
//
// INIT
//
// ********************************************************
initApp()
